import { createSlice } from "@reduxjs/toolkit";
import { cloneDeep } from "lodash";
import endpoints from "../config/endpoints";
import { apiGet } from "../utils/api_service";
const initialState = {
  year: [],
  activeYear: [],
  yearCompanyTarget: [],
  leaveYear: [],
  holidayYear: [],
  holiday: [],
  holidayStructure: [],
  holidayStructureAssignation: [],
  holidayStructureForSalesTeam: [],
  carryForwardLeave: [],
  leaveTypeForCarryForward: [],
  encashedLeave: [],
  leaveTypeForEncashed: [],
  optionalHoliday: [],
  isFetchYearCompanyTarget: false,
};
let URL = endpoints.year;
let leaveYearUrl = endpoints.leaveYear;
let holidayYearUrl = endpoints.holidayYear;
let holidayUrl = endpoints.holiday;
let holidayStructureHeaderUrl = endpoints.holidayStructureHeader;
let holidayStructureAssigantionUrl = endpoints.holidayStructureAssignation;
let carryForwardLeaveHeaderUrl = endpoints.carryForwardLeaveHeader;
let encashedLeaveHeaderUrl = endpoints.encashedLeaveHeader;

const yearSlice = createSlice({
  name: "year",
  initialState,
  reducers: {
    yearSuccess: (state = cloneDeep(initialState), action) => {
      const { row } = action.payload;
      return {
        ...state,
        year: row,
      };
    },

    leaveYearSuccess: (state = cloneDeep(initialState), action) => {
      const { row } = action.payload;
      return {
        ...state,
        leaveYear: row,
      };
    },

    holidayYearSuccess: (state = cloneDeep(initialState), action) => {
      const { row } = action.payload;
      return {
        ...state,
        holidayYear: row,
      };
    },


    holidayStructureSuccess: (state = cloneDeep(initialState), action) => {
      const { row } = action.payload;
      return {
        ...state,
        holidayStructure: row,
      };
    },

    holidayStructureForSalesTeamSuccess: (state = cloneDeep(initialState), action) => {
      const { row } = action.payload;
      return {
        ...state,
        holidayStructureForSalesTeam: row,
      };
    },


    holidayStructureAssignationSuccess: (state = cloneDeep(initialState), action) => {
      const { row } = action.payload;
      return {
        ...state,
        holidayStructureAssignation: row,
      };
    },


    holidaySuccess: (state = cloneDeep(initialState), action) => {
      const { row } = action.payload;
      return {
        ...state,
        holiday: row,
      };
    },



    yearActiveSuccess: (state = cloneDeep(initialState), action) => {
      const { row } = action.payload;
      return {
        ...state,
        activeYear: row,
      };
    },

    yearCompanyTargetSuccess: (state = cloneDeep(initialState), action) => {
      const { row } = action.payload;
      return {
        ...state,
        yearCompanyTarget: row,
        isFetchYearCompanyTarget: true,
      };
    },


    carryForwardLeaveSuccess: (state = cloneDeep(initialState), action) => {
      const { row } = action.payload;
      return {
        ...state,
        carryForwardLeave: row,
      };
    },


    encashedLeaveSuccess: (state = cloneDeep(initialState), action) => {
      const { row } = action.payload;
      return {
        ...state,
        encashedLeave: row,
      };
    },


    leaveTypeForCarryForwardSuccess: (state = cloneDeep(initialState), action) => {
      const { row } = action.payload;
      return {
        ...state,
        leaveTypeForCarryForward: row,
      };
    },

    leaveTypeForEncashedSuccess: (state = cloneDeep(initialState), action) => {
      const { row } = action.payload;
      return {
        ...state,
        leaveTypeForEncashed: row,
      };
    },

    optionalHolidaySuccess: (state = cloneDeep(initialState), action) => {
      const { row } = action.payload;
      return {
        ...state,
        optionalHoliday: row,
      };
    },

    resetState: (state = cloneDeep(initialState), action) => {
      return {
        ...state,
        ...initialState,
      };
    },
  },
});

export const {
  yearSuccess,
  targetRegionSuccess,
  yearCompanyTargetSuccess,
  yearActiveSuccess,
  leaveYearSuccess,
  holidayYearSuccess,
  holidaySuccess,
  holidayStructureSuccess,
  holidayStructureAssignationSuccess,
  holidayStructureForSalesTeamSuccess,
  carryForwardLeaveSuccess,
  encashedLeaveSuccess,
  leaveTypeForCarryForwardSuccess,
  leaveTypeForEncashedSuccess,
  optionalHolidaySuccess,
} = yearSlice.actions;

export default yearSlice.reducer;

export const getYear = () => async (dispatch) => {
  try {
    const response = apiGet({
      url: URL + '?sort={"fromDate": "ASC"}',
    }).then(({ data, success }) => {
      if (success) {
        const { content } = data.data;
        const row = content.map((yearObject, index) => {
          let yearData = {
            index: index + 1,
            id: yearObject.id === null ? "" : yearObject.id,
            yearName: yearObject.yearName === null ? "" : yearObject.yearName,
            name: yearObject.yearName === null ? "" : yearObject.yearName,
            fromDate: yearObject.fromDate === null ? "" : yearObject.fromDate,
            toDate: yearObject.toDate === null ? "" : yearObject.toDate,
            isActive: yearObject.isActive === null ? "" : yearObject.isActive,
          };
          return yearData;
        });
        dispatch(yearSuccess({ row }));
        return { response: row, success };
      }
      return { response: [], success };
    });
    return response;
  } catch (e) {
    return console.error(e.message);
  }
};

export const setYear =
  ({ row }) =>
    async (dispatch) => {
      dispatch(yearSuccess({ row }));
    };

export const getActiveYear = () => async (dispatch) => {
  try {
    const response = apiGet({
      url: URL + "/active",
    }).then(({ data, success }) => {
      if (success) {
        const row = data.data.map((yearObject, index) => {
          let yearData = {
            index: index + 1,
            id: yearObject.id === null ? "" : yearObject.id,
            yearName: yearObject.yearName === null ? "" : yearObject.yearName,
            name: yearObject.yearName === null ? "" : yearObject.yearName,
            fromDate: yearObject.fromDate === null ? "" : yearObject.fromDate,
            toDate: yearObject.toDate === null ? "" : yearObject.toDate,
            isActive: yearObject.isActive === null ? "" : yearObject.isActive,
          };
          return yearData;
        });
        dispatch(yearActiveSuccess({ row }));
        return { response: row, success };
      }
      return { response: [], success };
    });
    return response;
  } catch (e) {
    return console.error(e.message);
  }
};

export const getYearRegion =
  ({ regionId }) =>
    async (dispatch) => {
      try {
        const response = apiGet({
          url: URL + "/not-in-target-region-percentage?regionId=" + regionId,
        }).then(({ data, success }) => {
          if (success) {
            const row = data.data.map((yearRegionObj, index) => {
              let yearRegionData = {
                index: index + 1,
                id: yearRegionObj.id === null ? "" : yearRegionObj.id,
                yearName:
                  yearRegionObj.yearName === null ? "" : yearRegionObj.yearName,
                name:
                  yearRegionObj.yearName === null ? "" : yearRegionObj.yearName,
                fromDate:
                  yearRegionObj.fromDate === null ? "" : yearRegionObj.fromDate,
                toDate: yearRegionObj.toDate === null ? "" : yearRegionObj.toDate,
                isActive:
                  yearRegionObj.isActive === null ? "" : yearRegionObj.isActive,
                insertDateTime:
                  yearRegionObj.insertDateTime === null
                    ? ""
                    : yearRegionObj.insertDateTime,
              };
              return yearRegionData;
            });
            dispatch(yearSuccess({ row }));
            return { response: row, success };
          }
          return { response: [], success };
        });
        return response;
      } catch (e) {
        return console.error(e.message);
      }
    };

export const getYearCompanyTarget = () => async (dispatch) => {
  try {
    const response = apiGet({
      url: URL + "/not-in-company-target",
    }).then(({ data, success }) => {
      if (success) {
        const row = data.data.map((yearRegionObj, index) => {
          let yearRegionData = {
            index: index + 1,
            id: yearRegionObj.id === null ? "" : yearRegionObj.id,
            yearName:
              yearRegionObj.yearName === null ? "" : yearRegionObj.yearName,
            name: yearRegionObj.yearName === null ? "" : yearRegionObj.yearName,
            fromDate:
              yearRegionObj.fromDate === null ? "" : yearRegionObj.fromDate,
            toDate: yearRegionObj.toDate === null ? "" : yearRegionObj.toDate,
            isActive:
              yearRegionObj.isActive === null ? "" : yearRegionObj.isActive,
            insertDateTime:
              yearRegionObj.insertDateTime === null
                ? ""
                : yearRegionObj.insertDateTime,
          };
          return yearRegionData;
        });
        dispatch(yearCompanyTargetSuccess({ row }));
        return { response: row, success };
      }
      return { response: [], success };
    });
    return response;
  } catch (e) {
    return console.error(e.message);
  }
};



export const getLeaveYear = () => async (dispatch) => {
  try {
    const response = apiGet({
      url: leaveYearUrl + '?sort={"fromDate": "ASC"}',
    }).then(({ data, success }) => {
      if (success) {
        const { content } = data.data;
        const row = content.map((yearObject, index) => {
          let leaveYear = {
            index: index + 1,
            id: yearObject.id === null ? "" : yearObject.id,
            yearName: yearObject.yearName === null ? "" : yearObject.yearName,
            name: yearObject.yearName === null ? "" : yearObject.yearName,
            fromDate: yearObject.fromDate === null ? "" : yearObject.fromDate,
            toDate: yearObject.toDate === null ? "" : yearObject.toDate,
            isActive: yearObject.isActive === null ? "" : yearObject.isActive,
          };
          return leaveYear;
        });
        dispatch(leaveYearSuccess({ row }));
        return { response: row, success };
      }
      return { response: [], success };
    });
    return response;
  } catch (e) {
    return console.error(e.message);
  }
};

export const getActiveLeaveYear = () => async (dispatch) => {
  try {
    const response = apiGet({
      url: leaveYearUrl + "/get-active" + '?sort={"fromDate": "ASC"}',
    }).then(({ data, success }) => {
      if (success) {
        const row = data.data.map((yearObject, index) => {
          let leaveYear = {
            index: index + 1,
            id: yearObject.id === null ? "" : yearObject.id,
            yearName: yearObject.yearName === null ? "" : yearObject.yearName,
            name: yearObject.yearName === null ? "" : yearObject.yearName,
            fromDate: yearObject.fromDate === null ? "" : yearObject.fromDate,
            toDate: yearObject.toDate === null ? "" : yearObject.toDate,
            isActive: yearObject.isActive === null ? "" : yearObject.isActive,
          };
          return leaveYear;
        });
        dispatch(leaveYearSuccess({ row }));
        return { response: row, success };
      }
      return { response: [], success };
    });
    return response;
  } catch (e) {
    return console.error(e.message);
  }
};



export const getHolidayYear = () => async (dispatch) => {
  try {
    const response = apiGet({
      url: holidayYearUrl + '?sort={"fromDate": "ASC"}',
    }).then(({ data, success }) => {
      if (success) {
        const { content } = data.data;
        const row = content.map((yearObject, index) => {
          let holidayYear = {
            index: index + 1,
            id: yearObject.id === null ? "" : yearObject.id,
            yearName: yearObject.yearName === null ? "" : yearObject.yearName,
            name: yearObject.yearName === null ? "" : yearObject.yearName,
            fromDate: yearObject.fromDate === null ? "" : yearObject.fromDate,
            toDate: yearObject.toDate === null ? "" : yearObject.toDate,
            isActive: yearObject.isActive === null ? "" : yearObject.isActive,
          };
          return holidayYear;
        });
        dispatch(holidayYearSuccess({ row }));
        return { response: row, success };
      }
      return { response: [], success };
    });
    return response;
  } catch (e) {
    return console.error(e.message);
  }
}


export const getHoliday = () => async (dispatch) => {
  try {
    const response = apiGet({
      url: holidayUrl,
    }).then(({ data, success }) => {
      if (success) {
        const { content } = data.data;
        const row = content.map((yearObject, index) => {
          let holidayData = {
            index: index + 1,
            id: yearObject.id === null ? "" : yearObject.id,
            holidayName: yearObject.name === null ? "" : yearObject.name,
            day: yearObject.day === null ? "" : yearObject.day,
            dayForTable: yearObject.day === null ? "" : yearObject.day.toString().padStart(2, "0"),
            month: yearObject.month === null ? "" : yearObject.month,
            monthName: yearObject.month === null ? "" :
              yearObject.month == 1 ? "January" :
                yearObject.month == 2 ? "February" :
                  yearObject.month == 3 ? "March" :
                    yearObject.month == 4 ? "April" :
                      yearObject.month == 5 ? "May" :
                        yearObject.month == 6 ? "June" :
                          yearObject.month == 7 ? "July" :
                            yearObject.month == 8 ? "August" :
                              yearObject.month == 9 ? "September" :
                                yearObject.month == 10 ? "October" :
                                  yearObject.month == 11 ? "November" : "December",
            holidayType: 0,
          };
          return holidayData;
        });
        dispatch(holidaySuccess({ row }));
        return { response: row, success };
      }
      return { response: [], success };
    });
    return response;
  } catch (e) {
    return console.error(e.message);
  }
}


export const setHoliday =
  ({ row }) =>
    async (dispatch) => {
      dispatch(holidaySuccess({ row }));
    };


export const getHolidayStructureGetAll = () => async (dispatch) => {
  try {
    const response = await apiGet({
      url: holidayStructureHeaderUrl + "/get-all" + '?sort={"fromDate": "ASC"}',
    }).then(({ data, success }) => {
      if (success) {
        const row = data.data.map((structureObj, index) => {
          let holidayStructure = {
            index: index + 1,
            id: structureObj.id === null ? "" : structureObj.id,
            name: structureObj.name === null ? "" : structureObj.name,
            structureName: structureObj.name === null ? "" : structureObj.name,
            holidayYearMasterId: structureObj.holidayYearMaster !== null &&
              structureObj.holidayYearMaster.id !== null ? structureObj.holidayYearMaster.id : "",
            fromDate: structureObj.fromDate === null ? "" : structureObj.fromDate,
            toDate: structureObj.toDate === null ? "" : structureObj.toDate,
            optionalLeaveLimit: structureObj.optionalLimit === null ? "" : structureObj.optionalLimit,
            salesTeamCount: structureObj.salesTeamCount === null ? "" : structureObj.salesTeamCount,
            isActive: structureObj.isActive === null ? "" : structureObj.isActive,
          };
          return holidayStructure;
        });
        dispatch(holidayStructureSuccess({ row }));
        return { response: row, success };
      }
      return { response: [], success };
    });
    return response;
  } catch (e) {
    return console.error(e.message);
  }
}


export const getHolidayStructureActiveGetAll = () => async (dispatch) => {
  try {
    const response = apiGet({
      url: holidayStructureHeaderUrl + "/get-active" + '?sort={"fromDate": "ASC"}',
    }).then(({ data, success }) => {
      if (success) {
        const row = data.data.map((structureObj, index) => {
          let holidayStructure = {
            index: index + 1,
            id: structureObj.id === null ? "" : structureObj.id,
            name: structureObj.name === null ? "" : structureObj.name,
            structureName: structureObj.name === null ? "" : structureObj.name,
            holidayYearMasterId: structureObj.holidayYearMaster !== null &&
              structureObj.holidayYearMaster.id !== null ? structureObj.holidayYearMaster.id : "",
            fromDate: structureObj.fromDate === null ? "" : structureObj.fromDate,
            toDate: structureObj.toDate === null ? "" : structureObj.toDate,
            optionalLeaveLimit: structureObj.optionalLimit === null ? "" : structureObj.optionalLimit,
            holidayStructureDetails:
              structureObj.holidayStructureDetails === null ? "" :
                structureObj.holidayStructureDetails.map((dataObj, index) => {
                  let holidayStructureDetailsData = {
                    index: index + 1,
                    holidayId: dataObj.holiday !== null && dataObj.holiday.id !== null ?
                      dataObj.holiday.id : "",
                    day: dataObj.day === null ? "" : dataObj.day,
                    month: dataObj.month === null ? "" : dataObj.month,
                    holidayType: dataObj.holidayType === null ? "" : dataObj.holidayType,
                  }
                  return holidayStructureDetailsData;
                }),
          };
          return holidayStructure;
        });
        dispatch(holidayStructureSuccess({ row }));
        return { response: row, success };
      }
      return { response: [], success };
    });
    return response;
  } catch (e) {
    return console.error(e.message);
  }
}


export const getHolidayStructureAssignationGetAll = () => async (dispatch) => {
  try {
    const response = apiGet({
      url: holidayStructureAssigantionUrl,
    }).then(({ data, success }) => {
      if (success) {
        const { content } = data.data;
        const row = content.map((structureObj, index) => {
          let holidayStructureAssignationObj = {
            index: index + 1,
            id: structureObj.id === null ? "" : structureObj.id,
            salesTeamName: structureObj.salesTeam !== null &&
              structureObj.salesTeam.name !== null ?
              structureObj.salesTeam.name : "",
            salesTeamStockHolderTypName: structureObj.salesTeam !== null &&
              structureObj.salesTeam.stockStakeHolderType !== null &&
              structureObj.salesTeam.stockStakeHolderType.name !== null ?
              structureObj.salesTeam.stockStakeHolderType.name : "",
            structureName: structureObj.holidayStructureHeader !== null &&
              structureObj.holidayStructureHeader.name !== null ?
              structureObj.holidayStructureHeader.name : "",
            fromDate: structureObj.holidayStructureHeader !== null &&
              structureObj.holidayStructureHeader.fromDate !== null ?
              structureObj.holidayStructureHeader.fromDate : "",
            toDate: structureObj.holidayStructureHeader !== null &&
              structureObj.holidayStructureHeader.toDate !== null ?
              structureObj.holidayStructureHeader.toDate : "",
            salesTeamId: structureObj.salesTeam !== null &&
              structureObj.salesTeam.id !== null ?
              structureObj.salesTeam.id : "",
            salesTeamStockHolderTypId: structureObj.salesTeam !== null &&
              structureObj.salesTeam.stockStakeHolderType !== null &&
              structureObj.salesTeam.stockStakeHolderType.id !== null ?
              structureObj.salesTeam.stockStakeHolderType.id : "",
            isActive: structureObj.isActive === null ? "" : structureObj.isActive,
          };
          return holidayStructureAssignationObj;
        });
        dispatch(holidayStructureAssignationSuccess({ row }));
        return { response: row, success };
      }
      return { response: [], success };
    });
    return response;
  } catch (e) {
    return console.error(e.message);
  }
}

export const getSalesTeamWhoDoesNotHaveHolidayStructure =
  ({ holidayStructureHeaderId }) => async (dispatch) => {
    try {
      const response = apiGet({
        url: holidayStructureHeaderUrl +
          "/sales-team-not-having-assigned-record?holidayStructureHeaderId=" + holidayStructureHeaderId,
      }).then(({ data, success }) => {
        if (success) {
          const row = data.data.map((salesTeamObj, index) => {
            let holidayStrictureForSalesTeam = {
              index: index + 1,
              id: salesTeamObj.id === null ? "" : salesTeamObj.id,
              name: salesTeamObj.name === null ? "" : salesTeamObj.name,
              stockStakeHolderTypeId: salesTeamObj.stockStakeHolderTypeId === null ? "" : salesTeamObj.stockStakeHolderTypeId,
              stockStakeHolderTypeName: salesTeamObj.stockStakeHolderTypeName === null ? "" : salesTeamObj.stockStakeHolderTypeName,
              stockStakeHolderTypePrefix: salesTeamObj.stockStakeHolderTypePrefix === null ? "" : salesTeamObj.stockStakeHolderTypePrefix,
              userName: salesTeamObj.userName === null ? "" : salesTeamObj.userName,
              employeeCode: salesTeamObj.employeeCode === null ? "" : salesTeamObj.employeeCode,
              userTypeId: salesTeamObj.userTypeId === null ? "" : salesTeamObj.userTypeId,
              isChecked: false,
            };
            return holidayStrictureForSalesTeam;
          });
          dispatch(holidayStructureForSalesTeamSuccess({ row }));
          return { response: row, success };
        }
        return { response: [], success };
      });
      return response;
    } catch (e) {
      return { response: [], success: false };
    }
  }

export const setSalesTeamWhoDoesNotHaveHolidayStructure =
  ({ row }) =>
    async (dispatch) => {
      dispatch(holidayStructureForSalesTeamSuccess({ row }));
    };


export const getCarryForwardLeaveGetAll = () => async (dispatch) => {
  try {
    const response = apiGet({
      url: carryForwardLeaveHeaderUrl + "/get-all",
    }).then(({ data, success }) => {
      if (success) {
        const row = data.data.map((carryForwardObj, index) => {
          let carryForwardObjData = {
            index: index + 1,
            id: carryForwardObj.id === null ? "" : carryForwardObj.id,
            empCode:
              carryForwardObj.employeeCode !== null ?
                carryForwardObj.employeeCode : "",
            salesTeamId:
              carryForwardObj.salesTeamId !== null ?
                carryForwardObj.salesTeamId : "",
            salesTeamName:
              carryForwardObj.salesTeamName !== null ?
                carryForwardObj.salesTeamName : "",
            salesTeamType:
              carryForwardObj.designation !== null ?
                carryForwardObj.designation : "",
            reportingManagerType:
              carryForwardObj.reportingManagerType !== null ?
                carryForwardObj.reportingManagerType : "",
            reportingManagerName:
              carryForwardObj.reportingManagerName !== null ?
                carryForwardObj.reportingManagerName : "",
            reportingManagerId:
              carryForwardObj.reportingManagerId !== null ?
                carryForwardObj.reportingManagerId : "",
          };
          return carryForwardObjData;
        });
        dispatch(carryForwardLeaveSuccess({ row }));
        return { response: row, success };
      }
      return { response: [], success };
    });
    return response;
  } catch (e) {
    return console.error(e.message);
  }
}

export const getLeaveYearBySalesTeamId = ({ salesTeamId }) => async (dispatch) => {
  try {
    const response = apiGet({
      url: carryForwardLeaveHeaderUrl + "/get-leave-year-by-sales-team?salesTeamId=" + salesTeamId,
    }).then(({ data, success }) => {
      if (success) {
        const row = data.data.map((carryForwardObj, index) => {
          let carryForwardObjData = {
            index: index + 1,
            id: carryForwardObj.id === null ? "" : carryForwardObj.id,
            yearName:
              carryForwardObj.yearName !== null ?
                carryForwardObj.yearName : "",
            name:
              carryForwardObj.yearName !== null ?
                carryForwardObj.yearName : "",
            fromDate:
              carryForwardObj.fromDate !== null ?
                carryForwardObj.fromDate : "",
            toDate:
              carryForwardObj.toDate !== null ?
                carryForwardObj.toDate : "",

          };
          return carryForwardObjData;
        });
        dispatch(carryForwardLeaveSuccess({ row }));
        return { response: row, success };
      }
      return { response: [], success };
    });
    return response;
  } catch (e) {
    return console.error(e.message);
  }
}



export const getLeaveTypeBySalesTeamAndLeaveYear = ({ salesTeamId, leaveYearId }) => async (dispatch) => {
  try {
    const response = apiGet({
      url: carryForwardLeaveHeaderUrl
        + "/get-leave-type-by-sales-team-and-previous-leave-year-new?salesTeamId="
        + salesTeamId + "&leaveYearId=" + leaveYearId,
    }).then(({ data, success }) => {
      if (success) {
        const row = data.data;
        let dataObj = {
          leaveTypes: row.leaveTypes === null ? [] : row.leaveTypes.map((carryForwardObj, index) => {
            let carryForwardObjData = {
              index: index + 1,
              id: carryForwardObj.id === null ? "" : carryForwardObj.id,
              name:
                carryForwardObj.name !== null ?
                  carryForwardObj.name : "",
              carryForwardDays:
                carryForwardObj.carryForwardDays !== null ?
                  carryForwardObj.carryForwardDays : "",
              balance:
                carryForwardObj.balance !== null ?
                  carryForwardObj.balance : "",
              carryForwardLeave: 0,
            };
            return carryForwardObjData;
          }),
          leaveYearId: row.leaveYear && row.leaveYear.id !== null ? row.leaveYear.id : "",
          leaveYearName: row.leaveYear && row.leaveYear.yearName !== null ? row.leaveYear.yearName : "",
          fromDate: row.leaveYear && row.leaveYear.fromDate !== null ? row.leaveYear.fromDate : "",
          toDate: row.leaveYear && row.leaveYear.toDate !== null ? row.leaveYear.toDate : "",
          message: row.message !== null ? row.message : "",
          statusCode: row.statusCode !== null ? row.statusCode : "",
        }

        dispatch(leaveTypeForCarryForwardSuccess({ row: dataObj }));
        return { response: dataObj, success };
      }
      return { response: {}, success };
    });
    return response;
  } catch (e) {
    return { response: {}, success: false };
  }
}


export const getLeaveYearBySalesTeamIdForEncashed = ({ salesTeamId }) => async (dispatch) => {
  try {
    const response = apiGet({
      url: encashedLeaveHeaderUrl + "/get-leave-year-by-sales-team?salesTeamId=" + salesTeamId,
    }).then(({ data, success }) => {
      if (success) {
        const row = data.data.map((encashedLeaveObj, index) => {
          let encashedData = {
            index: index + 1,
            id: encashedLeaveObj.id === null ? "" : encashedLeaveObj.id,
            yearName:
              encashedLeaveObj.yearName !== null ?
                encashedLeaveObj.yearName : "",
            name:
              encashedLeaveObj.yearName !== null ?
                encashedLeaveObj.yearName : "",
            fromDate:
              encashedLeaveObj.fromDate !== null ?
                encashedLeaveObj.fromDate : "",
            toDate:
              encashedLeaveObj.toDate !== null ?
                encashedLeaveObj.toDate : "",

          };
          return encashedData;
        });
        dispatch(encashedLeaveSuccess({ row }));
        return { response: row, success };
      }
      return { response: [], success };
    });
    return response;
  } catch (e) {
    return console.error(e.message);
  }
}

export const getLeaveTypeBySalesTeamAndLeaveYearForEncashed = ({ salesTeamId, leaveYearId }) => async (dispatch) => {
  try {
    const response = apiGet({
      url: encashedLeaveHeaderUrl
        + "/get-leave-type-by-sales-team-and-previous-leave-year?salesTeamId="
        + salesTeamId + "&leaveYearId=" + leaveYearId,
    }).then(({ data, success }) => {
      if (success) {
        const row = data.data;

        let dataObject = {
          leaveTypes: row.leaveTypes === null ? [] : row.leaveTypes.map((encashedLeaveObj, index) => {
            let encashedLeaveData = {
              index: index + 1,
              id: encashedLeaveObj.id === null ? "" : encashedLeaveObj.id,
              name:
                encashedLeaveObj.name !== null ?
                  encashedLeaveObj.name : "",
              carryForwardDays:
                encashedLeaveObj.carryForwardDays !== null ?
                  encashedLeaveObj.carryForwardDays : "",
              balance:
                encashedLeaveObj.balance !== null ?
                  encashedLeaveObj.balance : "",
              encashedLeave: 0,
            };
            return encashedLeaveData;
          }),

          leaveYearId: row.leaveYear && row.leaveYear.id !== null ? row.leaveYear.id : "",
          leaveYearName: row.leaveYear && row.leaveYear.yearName !== null ? row.leaveYear.yearName : "",
          fromDate: row.leaveYear && row.leaveYear.fromDate !== null ? row.leaveYear.fromDate : "",
          toDate: row.leaveYear && row.leaveYear.toDate !== null ? row.leaveYear.toDate : "",
          message: row.message !== null ? row.message : "",
          statusCode: row.statusCode !== null ? row.statusCode : "",
        }

        dispatch(leaveTypeForEncashedSuccess({ row: dataObject }));
        return { response: dataObject, success };
      }
      return { response: {}, success };
    });
    return response;
  } catch (e) {
    return { response: {}, success: false };
  }
}

export const getOptionalHolidays = () => async (dispatch) => {
  try {
    const response = apiGet({
      url: holidayUrl + "/optional-holidays-taken-by-user",
    }).then(({ data, success }) => {
      if (success) {
        const row = data.data.map((yearObject, index) => {
          let holidayData = {
            index: index + 1,
            id: yearObject.id === null ? "" : yearObject.id,
            name: yearObject.name === null ? "" : yearObject.name,
            day: yearObject.day === null ? "" : yearObject.day,
            month: yearObject.month === null ? "" : yearObject.month,
            monthName: yearObject.month === null ? "" :
              yearObject.month == 1 ? "January" :
                yearObject.month == 2 ? "February" :
                  yearObject.month == 3 ? "March" :
                    yearObject.month == 4 ? "April" :
                      yearObject.month == 5 ? "May" :
                        yearObject.month == 6 ? "June" :
                          yearObject.month == 7 ? "July" :
                            yearObject.month == 8 ? "August" :
                              yearObject.month == 9 ? "September" :
                                yearObject.month == 10 ? "October" :
                                  yearObject.month == 11 ? "November" : "December",
          };
          return holidayData;
        });
        dispatch(optionalHolidaySuccess({ row }));
        return { response: row, success };
      }
      return { response: [], success };
    });
    return response;
  } catch (e) {
    return console.error(e.message);
  }
}


export const getOptionalHolidaysForSalesTeam = ({ salesTeamId }) => async (dispatch) => {
  try {
    const response = apiGet({
      url: holidayUrl + "/optional-holidays-of-below-sales-team?salesTeamId=" + salesTeamId,
    }).then(({ data, success }) => {
      if (success) {
        const row = data.data.map((yearObject, index) => {
          let holidayData = {
            index: index + 1,
            id: yearObject.id === null ? "" : yearObject.id,
            employeeCode: yearObject.employeeCode === null ? "" : yearObject.employeeCode,
            salesTeamId: yearObject.salesTeamId === null ? "" : yearObject.salesTeamId,
            salesTeamName: yearObject.salesTeamName === null ? "" : yearObject.salesTeamName,
            designation: yearObject.designation === null ? "" : yearObject.designation,
            name: yearObject.holidayName === null ? "" : yearObject.holidayName,
            day: yearObject.day === null ? "" : yearObject.day,
            month: yearObject.month === null ? "" : yearObject.month,
            monthName: yearObject.month === null ? "" :
              yearObject.month == 1 ? "January" :
                yearObject.month == 2 ? "February" :
                  yearObject.month == 3 ? "March" :
                    yearObject.month == 4 ? "April" :
                      yearObject.month == 5 ? "May" :
                        yearObject.month == 6 ? "June" :
                          yearObject.month == 7 ? "July" :
                            yearObject.month == 8 ? "August" :
                              yearObject.month == 9 ? "September" :
                                yearObject.month == 10 ? "October" :
                                  yearObject.month == 11 ? "November" : "December",
          };
          return holidayData;
        });
        dispatch(optionalHolidaySuccess({ row }));
        return { response: row, success };
      }
      return { response: [], success };
    });
    return response;
  } catch (e) {
    return console.error(e.message);
  }
}





export const getAvailableOptionalHolidays = ({ salesTeamId }) => async (dispatch) => {
  try {
    const response = apiGet({
      url: holidayStructureHeaderUrl + "/optional-remain-holidays-by-sales-team?salesTeamId=" + salesTeamId,
    }).then(({ data, success }) => {
      if (success) {
        const row = data.data.holidayStructureDetails.map((yearObject, index) => {
          let rowData = data.data;
          let holidayData = {
            index: index + 1,
            id: yearObject.id === null ? "" : yearObject.id,
            holidayId: yearObject.holidayId === null ? "" : yearObject.holidayId,
            holidayName: yearObject.holidayName === null ? "" : yearObject.holidayName,
            name: yearObject.holidayName === null ? "" : yearObject.holidayName,
            holidayStructureHeaderId: yearObject.holidayStructureHeaderId === null ? "" : yearObject.holidayStructureHeaderId,
            holidayType: yearObject.holidayType === null ? "" : yearObject.holidayType,
            month: yearObject.month === null ? "" : yearObject.month,
            headerId: rowData.id === null ? "" : rowData.id,
            holidayYearId: rowData.holidayYearId === null ? "" : rowData.holidayYearId,
            holidayYearName: rowData.holidayYearName === null ? "" : rowData.holidayYearName,
            fromDate: rowData.fromDate === null ? "" : rowData.fromDate,
            toDate: rowData.toDate === null ? "" : rowData.toDate,
            HeaderHolidayName: rowData.name === null ? "" : rowData.name,
            optionalLimit: rowData.optionalLimit === null ? "" : rowData.optionalLimit,
            optionalHolidaysTaken:
              rowData.optionalHolidaysTaken === null ? "" : rowData.optionalHolidaysTaken,
          };
          return holidayData;
        });
        dispatch(optionalHolidaySuccess({ row }));
        return { response: row, success };
      }
      return { response: [], success };
    });
    return response;
  } catch (e) {
    return console.error(e.message);
  }
}
